export default {
  id : 'Expression.FieldParser.ConstantNumberField',
  type : 'constantNumberField',
  sort : -7,
  handles : ( field, context ) => {
    if ( field.type === 'ExpressionParser.Field' && field.value != null ) {
      const trimmed = field.value.trim()
      return Number( trimmed ).toString() === trimmed
    }
    return false
  },
  parse : async ( field, context ) => {
    const toReturn = {
      type : 'ExpressionField.constantNumber',
      value : Number( field.value.trim() )
    }
    if ( context?.includeAstInfo ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.endIndex,
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : field.untrimmed?.length
      }
      toReturn.untrimmed = field.untrimmed
    }
    return toReturn
  }
}
